<template>
  <div class="content-card">
    <!-- 头部 -->
      <el-row type="flex" justify="space-between">
        <div><b style="font-size:18px;">{{title}}</b></div>
        <div v-if="showDatePick">
          <dataTime @changeDate="changeDate"/>
        </div>
        <div v-if="showDateSection">
          <el-radio-group v-model="activeDate" @change="dateSelection">
            <el-radio-button v-for="(label,index) in dateSelect" :label="label" :key="index">{{label}}</el-radio-button>
            <!-- <el-radio-button label="myself">自定义</el-radio-button>-->
          </el-radio-group>
        </div>
      </el-row>
    <!-- tab选项卡 -->
      <el-tabs v-model="activeName" @tab-click="tabSelection" class="clientPageTab">
        <el-tab-pane  v-for="item in tabNames" :label='item.label' :name="item.name">
        </el-tab-pane>
      </el-tabs>
    <!-- 展示图表 -->
      <div v-loading="isloading" ref="ClientEcharts" style="width:100%;height: 500px;"></div>
  </div>
</template>

<script>
import dataTime from "@/component/Client/filterTools/dataTime";
import {getClientChart} from "@/api/api";
import * as echarts from "echarts";
export default {
  name: "ClientCharts",
  props:{
    title:{
      type: String,
      required: true
    },
    showDatePick:{
      default: false
    },
    showDateSection:{
      default: false
    },
    tabNames:{
      type:Array,
      required:true
    }
  },
  components:{
    dataTime
  },
  watch:{
    // 监听this.activeName的变换，变换了重新去请求图表数据，也可以使用tabSelection事件监听
    activeName:{
      handler(value){
        this.activeName = value
        this.upCharts()
      }
    },
    // 监听this.activeDate的变换，变换了重新去请求图表数据，也可以使用dateSelection事件监听
    activeDate:{
      handler(value){
        this.activeDate = value
        this.upCharts()
      }
    }
  },
  data(){
    return {
      isloading:true, // 图表请求或切换时候需要展示骨架屏
      activeName:this.tabNames[0].name, //定义一个新变量存放props的 tabNames[0].name
      dateSelect:['近一个月','近三个月','近一年','今年以来','全部'],
      activeDate:'',// 默认为dateSelect的第一项，
      myChart:null
    }
  },
  mounted() {
      // 如果开启dateSelect选项，默认选中第一项。
      this.activeDate = this.dateSelect[0]
      this.initCharts()
  },
  methods: {
    // 如点击净订单、变现存量、上部的tab
    tabSelection(tab, event) {
      // 点击切换tab请求切换图表
      // console.log(tab.name)
      // console.log(tab.label)
    },

    //近一个月，近一年等事件变换之后的监听
    dateSelection(tab, event) {
      // 点击右边的选择对应的时间，如近一年
      // console.log(tab)
    },

    // 初始化图表
    async initCharts() {
      const {respData} = await getClientChart({indexname: this.activeName, time: this.activeDate})
      this.myChart = echarts.init(this.$refs.ClientEcharts);
      const initOption = this.handleOption(respData)
      this.myChart.setOption(initOption)
      this.isloading = false
    },

    // 处理数据，并获取最新的图表配置项
    handleOption(respData) {
      //  图表的所有展示项（如：中介服务，数字营销渠道业务等，需要变成series数组里面的每一个项）
      const quotation_type_list = respData.quotation_type_list
      //  图表的单个客户的所有数据
      const chartsData = respData.data
      // 用于收集客户名称，展示在x轴上
      const xAxis = []
      // 用户收集所有客户的某一个图表项的数据
      const series = []

      // 处理请求回来的图表数据，收集客户名称放入
      chartsData.forEach(item =>{
        // 客户名称，用于xAxis的显示
        let clientName = item.client
        xAxis.push(clientName)
      })

      quotation_type_list.forEach(keyName =>{
        // 一个客户的详细数据
        const seriesItem =  {
          name: keyName,
          type: 'bar',
          stack: 'total',
          label:{
            // show:true,
            formatter:function(e){
              if(e.value==0){
                return ''
              }else{
                return  `${e.value}`
              }
            },
          },
          emphasis: {
            focus: 'series'
          },
          data: []
        }
        chartsData.forEach(item =>{
          if(item.quotation_type.hasOwnProperty(keyName)){
            seriesItem.data.push(item.quotation_type[keyName].toFixed(0))
          }else{
            // 如果没有有某位客户没有该图表项，则用0占位
            seriesItem.data.push(0)
          }
        })
        series.push(seriesItem)
      })
      // console.log(xAxis,'xAxis')
      // console.log(series,'series')

      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        xAxis: {
          type: 'category',
          data: xAxis,
          axisLabel: {
            interval: 0 // 用于xAxis的全部展示！
          }
        },
        series: series
      }
    },

    // 更新图表
    async upCharts() {
      // 开启骨架屏
      this.isloading = true
      // 请求最新的数据
      const {respData} = await getClientChart({indexname: this.activeName, time: this.activeDate})
      const newOption = this.handleOption(respData)
      this.myChart.setOption(newOption)
      // 关闭骨架屏
      this.isloading = false
    }
  }
}
</script>

<style scoped>
.content-card {
  width: 95%;
  box-shadow:0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 5px;
  padding: 20px;
  margin-top: 20px;
}

.el-row {
  margin-bottom: 10px!important;
}

.el-radio-button >>> .el-radio-button__inner {
  padding: 5px 5px !important;
}

.clientPageTab >>> .el-tabs__item {
    min-width: 50px!important;
  }

</style>